import React, { Component } from 'react';
import { backgroundArtworks } from '../configs/backgroundArtworks.config';

var artwork =
  backgroundArtworks[Math.floor(Math.random() * backgroundArtworks.length)];
class SignUpChooser extends Component {
  // componentDidMount() {
  //   const { history } = this.props;
  //   setTimeout(() => history.push('/'), 500);
  // }

  goToConnectLoginPage = () => {
    const { history } = this.props;
    return history.push('/sign-up-to?returnTo=connect');
  };

  goToClientLoginPage = () => {
    const { history } = this.props;
    return history.push('/sign-up-to?returnTo=collect');
  };

  render() {
    return (
      <div
        className='home-page-wrapper'
        style={{ backgroundImage: `url(${artwork.asset})` }}
      >
        <div className='artwork-details'>
          <span className='artist-name'>{artwork.artistName}</span>
          <br />
          <span className='artwork-title'>
            {artwork.title}, {artwork.year}
          </span>
        </div>
        <span className='all-rights-reserved'>
          &copy; {new Date().getFullYear()} Arteïa - All rights reserved
        </span>
        <div className='content-wrapper'>
          <img src='/assets/logo-text.png' />
          <h1>You can choose between apps</h1>
          <div className='content-container'>
            <div className='text-with-icon'>
              <div className='text-container'>
                <img src='/ico-see-demo.svg' />
                <div>
                  <h2>
                    Collection Management
                    <br /> & Showrooms
                  </h2>
                  <span>Collection managing system</span>
                </div>
              </div>
              <button
                  className='collection-button-desktop'
                  onClick={() => this.goToClientLoginPage()}
                >
                  Sign up to Collection Management App
                </button>
                <button
                  className='collection-button-mobile'
                  onClick={() => this.goToClientLoginPage()}
                >
                  Sign up
                </button>
            </div>

            <div id='text-with-icon' className='text-with-icon'>
              <div className='text-container'>
                <img src='/ico-arteia-connect.svg' className='connect-img' />
                <div>
                  <h2>Connect</h2>
                  <span>
                    Connect physical art works with NFC tags to enable digital
                    authentication
                  </span>
                </div>
              </div>
              <button
                className='connect-button-desktop'
                onClick={() => this.goToConnectLoginPage()}
              >
                Sign up to Connect
              </button>
              <button
                className='connect-button-mobile'
                onClick={() => this.goToConnectLoginPage()}
              >
                Sign up
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SignUpChooser.propTypes = {};
SignUpChooser.defaultProps = {};

export default SignUpChooser;



// WEBPACK FOOTER //
// ./src/scenes/SignUpChooser/SignUpChooser.js